import { useEffect, useState } from 'react';

const useContainerWidth = (ref) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const updateWidth = () => {
      setWidth(ref.current.offsetWidth);
    };

    // Update initial width
    updateWidth();

    // Create ResizeObserver to detect size changes
    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(ref.current);

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
    };
  }, [ref]);

  return width;
};

export default useContainerWidth;
